import GeoTIFF from 'ol/source/GeoTIFF';
import { Layer } from './layer';
//import TileLayer from 'ol/layer/Tile';
import TileLayer from 'ol/layer/WebGLTile';

export class GeoTiffLayer extends Layer {

    constructor(
        id: string,
        label: string,
        type: string,
        url: string,
    ) {
        super(id, label, type);
        if (url) {
            this.url = url;
        }
    }

    toOlLayer() {
        console.log('geotiff', this.id, this.label, this.url);

        const source = new GeoTIFF({
            sources: [
                {
                    // url: '/assets/top25r_extr/geotiff/top25r_extr_381_c.tif',
                    url: this.url,
                    // If your TIFF has a specific nodata value (like 0 or 255)
                    nodata: 0
                }
            ],

            interpolate: false
        });

        const tileLayer = new TileLayer({
            source: source,

            minZoom: 0,
            maxZoom: 9
        });
        tileLayer.set('customId', this.id)
        console.dir(tileLayer);

        return tileLayer;
        // throw new Error('Method not implemented.');
    }
}
